export const businessDetailsSelector = (state) => ({
  businessDetails: state.businessDetails
});
